/**
 * Global ConfigProvider settings for antd components.
 * These are passed to ConfigProvider alongside the theme object.
 */
export const formConfig = {
  requiredMark: false as const,
};
